import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Title from './Title';
import SubTitle from './SubTitle';

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
  },
  contentWrapper: {
    maxWidth: ({ width }: { width: number }) => width,
  },
}));

export default function Header({ title, subtitle = null, width }) {
  const classes = useStyles({ width });

  return (
    <>
      {(title || subtitle) && (
        <div className={classes.headerContainer}>
          <div className={classes.contentWrapper}>
            <Title title={title} />
            <SubTitle subtitle={subtitle} />
          </div>
        </div>
      )}
    </>
  );
}
